module.exports = __webpack_public_path__ + "static/media/team_expand.202f98f5.png";